import isObjectLike from 'lodash/isObjectLike';
import isString from 'lodash/isString';
import { SpecTypes } from './constants';
export const isCorrectSpec = (candidate) => isObjectLike(candidate) &&
    (candidate.type === SpecTypes.Array ||
        candidate.type === SpecTypes.Boolean ||
        candidate.type === SpecTypes.Number ||
        candidate.type === SpecTypes.Object ||
        candidate.type === SpecTypes.String) &&
    isObjectLike(candidate.viewSpec) &&
    isString(candidate.viewSpec.type);
export const isArraySpec = (candidate) => (candidate === null || candidate === void 0 ? void 0 : candidate.type) === SpecTypes.Array;
export const isBooleanSpec = (candidate) => (candidate === null || candidate === void 0 ? void 0 : candidate.type) === SpecTypes.Boolean;
export const isNumberSpec = (candidate) => (candidate === null || candidate === void 0 ? void 0 : candidate.type) === SpecTypes.Number;
export const isObjectSpec = (candidate) => (candidate === null || candidate === void 0 ? void 0 : candidate.type) === SpecTypes.Object;
export const isStringSpec = (candidate) => (candidate === null || candidate === void 0 ? void 0 : candidate.type) === SpecTypes.String;
